import Vue from 'vue';
import Vuex from 'vuex';

import collections from './modules/collections';
import testResult from './modules/test-result';
import profile from './modules/profile';
import progress from './modules/progress';
import marathon from './modules/marathon';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    collections,
    testResult,
    profile,
    progress,
    marathon,
  },
});
